<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Scenarios-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @rightTextClick="addScenario" v-if="$store.getters.language.texts.isRTL" :rightText="$store.getters.language.texts.Scenarios_addScenario" rightIcon="plus" centerText=""></TopNav>
        <TopNav @leftTextClick="addScenario" v-else rightText="" :leftText="$store.getters.language.texts.Scenarios_addScenario" leftIcon="plus" centerText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Scenarios-main-wrapper lxn-pos-rel">
      <div class="Scenarios-wrapper-main-scenarios lxn-margin-auto lxn-border-round lxn-pos-rel lxn-overflow-hidden">
        <div v-if="scenarios.length === 0" class="Scenarios-wrapper-noScenarios lxn-text-center" :class="[$store.getters.language.directionClass, $store.getters.language.font]">
          {{$store.getters.language.texts.Scenarios_noscenario}}
        </div>
        <div v-for="(scenario, index) in scenarios" :key="index" class="Scenarios-wrapper-scenarios lxn-w100 lxn-border-round lxn-overflow-hidden">
          <div class="Scenarios-wrapper-colorBar lxn-h100" :class="$store.getters.language.floatClass" :style="colorBar(index)">
          </div>
          <div class="Scenarios-Scenario-icon lxn-h100" :class="$store.getters.language.floatClass">
            <ButtonIcon :size="40" bgColor="#53636C" icon="scenario" iconColor="#FFFFFF" :padding="8" />
          </div>
          <div class="Scenarios-wrapper-Scenario-text lxn-h100" :class="$store.getters.language.floatClass">
            <div class="Scenarios-Scenario-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{scenario.name}}
            </div>
            <div class="Scenarios-Scenario-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.getHubByUUID(scenario.hubUUID).name}}
            </div>
          </div>
          <div class="Scenarios-Scenario-setting lxn-h100" :class="$store.getters.language.floatClass">
            <ButtonIcon @click="editScenario(index)" :size="50" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'Scenarios',
  components: {
    CustomCurve,
    TopNav,
    ButtonIcon
  },
  mounted: function () {
    this.$store.commit('setAppBusy', true);
    setTimeout(() => {
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        this.getHubScenarios(i)
      }
    }, 2000)
  },
  destroyed: function () {
  },
  data: function () {
    return {
      scenarios: []
    }
  },
  methods: {
    openMenu: function () {
      this.$root.openMenu();
    },
    addScenario: function () {
      this.$router.push('/addScenario');
    },
    editScenario: function (index) {
      this.$router.push('/editScenario/' + this.scenarios[index].scenarioId);
    },
    colorBar: function (index) {
      return "background-color: " + this.$store.state.themeMainColors[this.scenarios[index].color] + ";";
    },
    getHubScenarios: function (hubIndex) {
      const hub = this.$store.state.hubs[hubIndex];
      const psk = hub.psk;
      const destinationUUID = hub.uuid;
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('getHubScenarios', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
      })
      .then(response => {
        const scenarios = response.body.bodyContent.scenarioList;
        let scenarioState = this.$store.state.scenarios;
        scenarios.filter(x => !scenarioState.map(s => s.scenarioId).includes(x.scenarioId)).forEach(x => {
          this.$store.commit('addScenario', {
            name: this.$store.getters.language.texts.Scenarios_scenarioCommonName,
            color: 0,
            hubUUID: hub.uuid,
            scenarioId: x.scenarioId,
          });
        });
        scenarioState.filter(x => !scenarios.map(s => s.scenarioId).includes(x.scenarioId)).forEach(x => {
          this.$store.commit('deleteScenario', x.scenarioId);
        });
        this.$store.commit('saveState');
        scenarioState = this.$store.state.scenarios;
        this.scenarios = scenarios.map(x => {
          return scenarioState.find(s => s.scenarioId === x.scenarioId);
        });
        this.$store.commit('setAppBusy', false);
        this.$store.commit('saveState');
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      });
    }
  }
}
</script>

<style>
  .Scenarios-topCurve-wrapper {
    height: 150px;
  }
  .Scenarios-main-wrapper {
    margin-top: -100px;
    margin-bottom: 14px;
    z-index: 2;
  }
  .Scenarios-wrapper-noScenarios {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .Scenarios-wrapper-main-scenarios {
    width: calc(100% - 36px);
    background-color: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    z-index: 1;
    margin-bottom: 14px;
  }
  .Scenarios-wrapper-scenarios {
    height: 50px;
    background-color: #ECECEC;
    margin-bottom: 14px;
  }
  .Scenarios-wrapper-scenarios:first-child {
    margin-top: 4px;
  }
  .Scenarios-Scenario-icon {
    width: 50px;
    padding: 5px;
  }
  .Scenarios-wrapper-colorBar {
    width: 8px;
  }
  .Scenarios-wrapper-Scenario-text {
    width: calc(100% - 108px);
  }
  .Scenarios-Scenario-text {
    height: 25px;
    line-height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    color: #52626C;
  }
  .Scenarios-Scenario-setting {
    width: 50px;
  }
</style>